import { Route } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { QrCodeInfoComponent } from './settings/qr-code-gen/qr-code-info/qr-code-info.component';
import { AuthGuard } from './auth.guard';
import { RoleGuard } from './shared/guards/role.guard';
import { LoginComponent } from './authority/login/login.component';
import { ResetPasswordComponent } from './authority/reset password/reset-password.component';
import { ForgotPasswordComponent } from './authority/forgot-password/forgot-password.component';
import { AccessDeniedComponent } from './authority/access-denied/access-denied.component';
import { PrivacyPolicyComponent } from './legal/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './legal/terms-of-service/terms-of-service.component';
import { ImpressumComponent } from './legal/impressum/impressum.component';
import { RestoreAccountComponent } from './authority/restore-account/restore-account.component';
import { RestoreClinicComponent } from './authority/restore-clinic/restore-clinic.component';
import { ForgotPasswordConfirmComponent } from './authority/forgot-password-confirm/forgot-password-confirm.component';
import { ClaimAccountComponent } from './authority/claim-account/claim-account.component';
import { ConfirmEmailComponent } from './authority/confirm-email/confirm-email.component';
import { ActivateAccountComponent } from './authority/activate-account/activate-account.component';
import { ConfirmTransferComponent } from './authority/confirm-transfer/confirm-transfer.component';
import { ConfirmShareComponent } from './authority/confirm-share/confirm-share.component';
import { AppDownloadComponent } from './authority/app-download/app-download.component';
import { PetGalleryShareOpenComponent } from './pet-gallery/pet-gallery-share-open.component';

/**
 * Application routes with OpenIddict authentication & authorization
 *
 * - AuthGuard: Checks if user has valid JWT token (authentication)
 * - RoleGuard: Checks if user has required role (authorization)
 *
 * Example with role-based access:
 * {
 *   path: 'admin',
 *   component: AdminComponent,
 *   canActivate: [AuthGuard, RoleGuard],
 *   data: { roles: ['Administrator'] }
 * }
 */
export const appRoutes: Route[] = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['Administrator', 'ClinicOwner', 'Clinic', 'Manager'] },
    // To add role-based protection to shell routes, add:
    // canActivate: [AuthGuard, RoleGuard],
    // data: { roles: ['Administrator', 'ClinicOwner', 'Clinic', 'Veterinarian'] }
  },
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'change-password', component: ResetPasswordComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'access-denied', component: AccessDeniedComponent },

  {
    path: 'qr-code-info/:uid',
    component: QrCodeInfoComponent,
  },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent },
  { path: 'impressum', component: ImpressumComponent },
  { path: 'restore-account', component: RestoreAccountComponent },
  { path: 'restore-clinic', component: RestoreClinicComponent },
  { path: 'claim-account', component: ClaimAccountComponent },
  { path: 'activate-account', component: ActivateAccountComponent },
  { path: 'confirm-email', component: ConfirmEmailComponent },
  { path: 'confirm-transfer', component: ConfirmTransferComponent },
  { path: 'confirm-share', component: ConfirmShareComponent },
  { path: 'download/:appType', component: AppDownloadComponent },
  {
    path: 'pet-gallery/share/:postUid',
    component: PetGalleryShareOpenComponent,
  },
  {
    path: 'forgot-password-confirmation',
    component: ForgotPasswordConfirmComponent,
  },
];
